/* eslint-disable no-unreachable */
import Utils from "./libs/snake.lib.utils.js";
import Hook from "./libs/snake.lib.hook.js";
import Trace from "./libs/snake.lib.trace.js";
import Identity from "./libs/snake.lib.identity.js";
import Storage from "./libs/snake.lib.storage.js";
import AnalyticsService from "./libs/snake.lib.analytics.js";
import Validate from "./libs/snake.lib.validate.js";
import Component from "./component.js";
import config from "./config.js";
import ApiService from "./libs/snake.lib.api.js";
import AdyenCheckout from "@adyen/adyen-web";
import Url from "./libs/snake.lib.url.js";
import ComponentAddresses from "./component.addresses.js";
import Summary from "./libs/snake.lib.summary.js";

export default class ComponentPayment {
    static modalI18nGenericOptions;
    static #componentDom;
    static #dropinErrorBox;
    static #availableConsents = ["GDPRPromo", "GDPRPromo3rd", "GDPRProfiling", "GDPROptInSMS"];

    static init = async () => {
        Trace.debug("Component _cmpPayment");

        // FR-2434
        Summary.showReducedVersion(3);

        AnalyticsService.checkoutPaymentLoad();

        this.modalI18nGenericOptions = Component.getModalI18nGenericOptions();
        this.#componentDom = document.getElementById(config.routing.sections.payment.component);
        this.#dropinErrorBox = document.getElementById("dropin-outcome");

        this.#componentDom.querySelector("loader").innerLoader(true);

        /**
         * Save the user default shipping address on Local Storage to be able to use it on the Thank You page
         */
        const defaultShippingAddress = (Array.isArray(window.snakeCheckout.accountInfo.data.shippingAddresses) ? window.snakeCheckout.accountInfo.data.shippingAddresses : []).filter((address) => address.defaultAddress);
        Storage.set("shipping_address", JSON.stringify(defaultShippingAddress[0]));

        Component.scrollTo(config.routing.sections.payment.component);

        const upsellingFK = Url.getParametes("testId");

        if (window.snakeCheckout.type === "subscription" && upsellingFK === "fk-upsell-001") {
            ApiService.getFullKitUpselling(window.snakeCheckout.initData.products[0].sku)
                .then((response) => {
                    AnalyticsService.fullKitUpSelling("view_upselling_popup");
                    const element = document.querySelector("[data-modal='fullKitUpselling']");
                    document.querySelector(".heading-modal-subscription").innerHTML = response?.data?.modal?.heading || "";
                    if (response?.data?.modal?.ribbon) {
                        document.querySelector(".ribbon-modal-subscription").innerHTML = response?.data?.modal?.ribbon;
                    } else {
                        document.querySelector(".ribbon-modal-subscription").classList.add("hidden");
                    }
                    document.querySelector(".title-modal-subscription").innerHTML = response?.data?.modal?.title || "";
                    document.querySelector(".bullets-title-modal-subscription").innerHTML = response?.data?.modal?.bullets?.title || "";
                    document.querySelector(".switch-label-modal-subscription").innerHTML = response?.data?.modal?.ctas?.switch?.label || "";
                    document.querySelector(".undo-label-modal-subscription").innerHTML = response?.data?.modal?.ctas?.undo?.label || "";
                    document.querySelector(".switch-button-modal-subscription").href = response?.data?.modal?.ctas?.switch?.href || "";
                    document.querySelector(".undo-button-modal-subscription").addEventListener("click", () => {
                        AnalyticsService.fullKitUpSelling("keep_standard");
                        element.classList.add("hidden");
                    });
                    document.querySelector(".switch-button-modal-subscription").addEventListener("click", () => {
                        AnalyticsService.fullKitUpSelling("move_fullkit");
                    });
                    element.querySelectorAll("[data-close]").forEach((closeAction) => {
                        closeAction.addEventListener("click", () => {
                            element.classList.add("hidden");
                        });
                    });
                    document.querySelector(".chip-modal-subscription").innerHTML = response?.data?.modal?.chipText || "";

                    const imgBanner = document.querySelector(".banner-modal-subscription");
                    imgBanner.src = response?.data?.modal?.banner;

                    response?.data?.modal?.bullets?.dots?.forEach((component) => {
                        document.querySelector(".bullets-dots-modal-subscription").innerHTML += "<li class='list-none flex gap-2 items-center'><div class='imgBullet w-4 h-4 bg-contain shrink-0'></div><span>" + component + "</span></li>";
                    });
                    if (response.data.modal.show) {
                        document.getElementById("modalFullKitUpselling").classList.remove("hidden");
                    }
                })
                .catch((e) => {
                    AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | get FullKit Upselling info error", e);
                });
        }

        if (window.snakeCheckout.type === "subscription" && ["us", "uk", "it", "de"].includes(window.snakeCheckout.currentCountry)) {
            ApiService.getKlarna(window.snakeCheckout.initData.products[0].code)
                .then((response) => {
                    if (response.data.isFullKit && response.data.amount !== 0) {
                        document.getElementById("klarna-widget-container").innerHTML = `<klarna-placement id="klarna-message" data-key="credit-promotion-auto-size" data-locale="${response.data.locale}" data-purchase-amount="${response.data.amount}00"></klarna-placement>`;

                        window.KlarnaOnsiteService.push({ eventName: "refresh-placements" });
                    }
                })
                .catch((e) => {
                    AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | get klarna info error", e);
                });
        }

        if (Identity.isAgent()) {
            this.#componentDom.querySelector("#agent-send-pay-link").classList.remove("hidden");

            Hook.subscribe("_agentSendPayLink", async () => {
                Utils.spinner("loader", true);

                await ApiService.sendPayLink(window.snakeCheckout.initData.cart_id)
                    .then(async () => {
                        window.location.href = "/" + config.countries[window.snakeCheckout.currentCountry].countryCode.toLowerCase() + (window.snakeCheckout.type === "subscription" ? "/subscribe/" : "/purchase/") + "confirmation-mail-agent";
                    })
                    .catch((e) => {
                        Utils.spinner("loader", false);

                        Utils.modal("popup", true, this.modalI18nGenericOptions);

                        AnalyticsService.errorEvent("3_payment", "technical", "agent, snakeAPI | send pay link error", e);
                    });
            });

            this.#componentDom.querySelector("#flag-agent-send-pay-link").addEventListener("change", (e) => {
                this.#componentDom.querySelector("#agent-send-pay-link button").disabled = e.target.checked;
            });
        }

        if (window.snakeCheckout.type === "subscription") {
            this.#getSpecialGiftImage()
                .then((response) => {
                    if (response.image) {
                        const imgWrapperDom = this.#componentDom.querySelector("#gift-image");

                        imgWrapperDom.querySelector("img").src = response.image;
                        imgWrapperDom.querySelector("div").innerHTML = response.title || "";
                        imgWrapperDom.querySelector("span").innerHTML = response.subtitle || "";
                        imgWrapperDom.classList.add("mb-5", "p-4");
                    }
                })
                .catch((e) => {
                    AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | get special gift image error", e);
                });
        }

        const skus = window.snakeCheckout.initData.products.map((product) => product.sku);

        await Identity.getAvailablePromotions(skus).then(async (promotions) => {
            Trace.debug("getAvailablePromotions");
            Trace.debug(promotions);

            if (promotions) {
                window.snakeCheckout.promotions = promotions;

                const promoDom = this.#componentDom.querySelector(".promocode-placeholder").parentElement;

                promotions.forEach((promotion) => {
                    if (!promotion.auto) {
                        promoDom.querySelector(":scope form input").value = promotion.code;
                        promoDom.setAttribute("open", true);
                    }
                });
            }
        });

        // Identity.getAvailablePromotions().then((response) => {
        //     if (response[0]) {
        //         this.#componentDom.querySelector(".promocode-placeholder").innerHTML = window.snakeCheckout.translations["promo.placeholder.custom"].replace("%s", response[0].code);
        //     }
        // });

        /**
         * If PL or IT handle invoice form and flag
         */
        if (["pl", "it"].includes(window.snakeCheckout.currentCountry)) {
            const invoiceCheck = document.getElementById("invoice-check");
            const invoiceForm = document.getElementById("invoice-form");

            invoiceCheck.checked = false;

            if (!invoiceForm.dataset.validationAttached) {
                Validate.attach(invoiceForm, (formIsValid) => {
                    this.#validateOrderButton();
                });
            }

            invoiceCheck.addEventListener("change", (e) => {
                if (e.target.checked) invoiceForm.classList.remove("hidden");
                else invoiceForm.classList.add("hidden");

                this.#validateOrderButton();
            });
        }

        /**
         * If not US handle T&C flag
         */
        if (window.snakeCheckout.currentCountry !== "us") {
            const termsFlag = document.getElementById("accept-terms");

            termsFlag.checked = false;

            document.querySelector("[for='accept-terms']").innerHTML = window.snakeCheckout.translations["payment.consent"].replace("%s", window.snakeCheckout.termsAndConditionsUrl);

            termsFlag.addEventListener("change", () => {
                this.#validateOrderButton();
            });
        }

        this.#renderConsents();

        /**
         * Warn customer when click on disabled payment button
         */
        this.#componentDom.querySelectorAll("#btn-dropin-generic, #btn-dropin-paypal.disabled").forEach((btn) => {
            btn.addEventListener("click", () => {
                this.#validateOrderButton();
            });
        });

        const testId = Url.getParametes("testId");

        await ApiService.paymentInit({
            cart_id: window.snakeCheckout.initData.cart_id,
            order_id: parseInt(Storage.get("order")),
            full_price: testId === "10052023" || testId === "29072024",
        })
            .then(async (response) => {
                Trace.debug("paymentInit");
                Trace.log(response);

                if (response.data) {
                    window.snakeCheckout.iod = response.data.session.reference;
                    window.snakeCheckout.orderId = response.data.order_id;

                    /**
                     * Save the order ID in local storage to avoid generating a new order if it already exists
                     */
                    Storage.set("order", response.data.order_id);

                    /**
                     * Save the customer first name in local storage to retrive for the Verify flow
                     */
                    Storage.set("firstname", window?.snakeCheckout?.accountInfo?.profile?.firstName || "");

                    const adyenCheckoutInstance = await this.#adyenCheckoutInit(response.data.session);

                    await this.#renderAdyenDropin(adyenCheckoutInstance);

                    const autoPromotions = window.snakeCheckout.promotions.map((promotion) => {
                        return promotion.auto ? promotion : {};
                    });

                    // autoPromotions = [...autoPromotions, { auto: false, code: "40_DIP" }]; // just for test

                    if (autoPromotions.length !== 0) {
                        await ApiService.purchaseAddCoupon({
                            coupon_codes: autoPromotions,
                            order_id: response.data.order_id,
                        })
                            .then((coupon) => {
                                Trace.debug("purchaseAddCoupon auto response");
                                Trace.log(coupon);

                                const promoBoxDom = document.querySelectorAll(".promo-box");

                                autoPromotions.forEach((autoPromotion) => {
                                    promoBoxDom.forEach((box) => {
                                        if (box.childElementCount !== 1) {
                                            box.lastElementChild.classList.add("mb-3");
                                            box.appendChild(box.firstElementChild.cloneNode(true));
                                        }

                                        box.lastElementChild.innerHTML = window.snakeCheckout.dictionary["promo." + autoPromotion.code] || "[Dictionary]: promo." + autoPromotion.code;

                                        box.classList.remove("hidden");
                                    });
                                });

                                document.querySelector("#toggle-mobile-summary div:not(:first-child)").classList.remove("hidden");

                                Storage.set(
                                    "promotions",
                                    autoPromotions.map((promotion) => promotion.code)
                                );

                                document.querySelector("details").remove();
                            })
                            .catch((e) => {
                                Trace.debug("purchaseAddCoupon auto error");
                                Trace.debug(e);

                                Utils.modal("popup", true, this.modalI18nGenericOptions);

                                AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | add coupon auto error", e);

                                // Utils.modal("popup", true, { text: window.snakeCheckout.translations["promo.notvalid"], dismissBtn: this.modalI18nGenericOptions.dismissBtn });
                            });
                    }

                    /**
                     * TEMP
                     */
                    // const initData = JSON.parse(Storage.get("init"));
                    // Storage.set("init", JSON.stringify(initData));
                    // Storage.set("payment_method", "card");
                    // Storage.set("firstname", window.snakeCheckout.accountInfo.profile.firstName || "");
                    /**
                     * TEMP
                     */
                } else throw Error(response.error.message || "payment init response data error");
            })
            .catch((e) => {
                document.querySelectorAll("#btn-dropin-paypal, #btn-dropin-generic").forEach((element) => element.remove());

                Utils.modal("popup", true, this.modalI18nGenericOptions);

                AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | payment init error", e);
            });

        /**
         * Listener to intercept the set Promo Code user action
         */
        Hook.subscribe("_setPromoCode", async (e) => {
            Utils.spinner("loader", true);

            const promoDom = e.detail.event.target.closest("details");
            const couponCode = promoDom.querySelector("input").value.trim();

            if (couponCode) {
                const promotions = [...window.snakeCheckout.promotions];
                const couponAlreadyUsed = (promotions.find((promotion) => promotion.code === couponCode) ?? []).length !== 0;

                Trace.debug("couponAlreadyUsed");
                Trace.debug(couponAlreadyUsed);

                if (!couponAlreadyUsed) {
                    promotions.push({
                        code: couponCode,
                        auto: false,
                    });

                    await ApiService.purchaseAddCoupon({
                        coupon_codes: promotions,
                        order_id: Storage.get("order"),
                    })
                        .then((response) => {
                            Trace.debug("purchaseAddCoupon response:");
                            Trace.log(response);

                            const checkCouponCode = response?.data?.coupon_codes.filter((coupon) => coupon.code === couponCode);

                            Trace.log(checkCouponCode);

                            if (checkCouponCode.length !== 0) {
                                const promoDom = this.#componentDom.querySelector(".promocode-placeholder").parentElement;

                                promoDom.classList.add("border-green");

                                promoDom.querySelector(":scope form").classList.add("border-b", "mb-6", "pb-6");

                                promoDom.lastElementChild.classList.add("mb-3");

                                promoDom.appendChild(promoDom.lastElementChild.cloneNode(true));

                                promoDom.lastElementChild.firstElementChild.innerText = window.snakeCheckout.dictionary["promo." + couponCode] || "[Dictionary]: promo." + couponCode;

                                promoDom.lastElementChild.classList.remove("mb-3");

                                promoDom.lastElementChild.classList.remove("hidden");

                                window.snakeCheckout.promotions.push({
                                    code: couponCode,
                                    auto: false,
                                });

                                Storage.set(
                                    "promotions",
                                    window.snakeCheckout.promotions.map((promotion) => promotion.code)
                                );
                            }
                        })
                        .catch((e) => {
                            Trace.debug(e);

                            // Utils.modal("popup", true, this.modalI18nGenericOptions);

                            Utils.modal("popup", true, { text: window.snakeCheckout.translations["promo.notvalid"], dismissBtn: this.modalI18nGenericOptions.dismissBtn });

                            AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | add coupon error", e);
                        });
                }
            }

            Utils.spinner("loader", false);
        });

        /**
         * Listener to intercept the Create Order user action
         */
        Hook.subscribe("_createOrder", async (e) => {
            if (!ComponentAddresses.validateCifNif()) return;

            if (!this.#validateOrderButton()) return;

            if (!(await this.#saveInvoiceData())) return;

            if (!(await this.#saveConsents())) return;

            AnalyticsService.checkoutPaymentExecute();

            await this.#submitOrder();
        });

        this.#componentDom.querySelector("loader").innerLoader(false);

        Component.setCheckoutStepsVisibility([config.routing.sections.payment.component], true);
    };

    static #getSpecialGiftImage = async () => {
        const response = await fetch(import.meta.env.CO_SNAKE_API_CACHED + "/api/v1/core/service/product/gift?country=" + window.snakeCheckout.currentCountry + "&code=" + window.snakeCheckout.initData.products[0].code);

        if (!response.ok) throw Error(response);

        return await response.json();
    };

    static #renderConsents = async () => {
        if (!window.snakeCheckout.accountInfo.userConsents) {
            await Identity.getConsents()
                .then((response) => {
                    this.#componentDom.querySelector("#disclaimer-title").innerHTML = window.snakeCheckout.translations["payment.consents.title"];
                    this.#componentDom.querySelector("#disclaimer").innerHTML = response.disclaimer.text.replace(/:*$/, "");

                    window.snakeCheckout.accountInfo.userConsents = [];

                    if (window.snakeCheckout.currentCountry !== "us") this.#availableConsents = ["GDPRPromo", "GDPRProfiling", "GDPRPromo3rd", "GDPROptInSMS"];

                    this.#availableConsents.forEach((consentKey) => {
                        window.snakeCheckout.accountInfo.userConsents.push({
                            key: consentKey,
                            text: response.consents.filter((item) => item.key === consentKey)[0]?.text || "",
                            granted: (consentKey) => {
                                let consentValue = null;

                                if (window.snakeCheckout.currentCountry !== "us" && consentKey === "GDPROptInSMS") consentValue = true;

                                if (window.snakeCheckout.currentCountry === "us" && ["GDPRPromo", "GDPRProfiling"].includes(consentKey)) consentValue = true;

                                // if (["de", "at", "nl", "uk", "pl", "gr", "cz", "it"].includes(window.snakeCheckout.currentCountry) && consentKey === "GDPRPromo3rd") consentValue = true;
                                // if (window.snakeCheckout.currentCountry !== "us" && consentKey === "GDPROptInSMS") consentValue = true;
                                // if (window.snakeCheckout.currentCountry === "us" && ["GDPRPromo", "GDPRPromo3rd", "GDPRProfiling"].includes(consentKey)) consentValue = true;

                                if (consentValue === null) consentValue = response.consents.filter((item) => item.key === consentKey)[0]?.granted || false;

                                return consentValue;
                            },
                        });
                    });

                    const consentsWrapper = this.#componentDom.querySelector("#consents");
                    const consentsElementTemplate = consentsWrapper.querySelector("template");

                    window.snakeCheckout.accountInfo.userConsents
                        .filter((consent) => !consent.granted(consent.key))
                        .forEach((consent) => {
                            const clone = consentsElementTemplate.content.cloneNode(true);
                            const cloneLabel = clone.querySelector("label");
                            const cloneInput = clone.querySelector("input");

                            cloneInput.checked = false;
                            cloneLabel.textContent = consent.text;
                            cloneLabel.htmlFor = cloneInput.id = cloneInput.name = consent.key;

                            consentsWrapper.appendChild(clone);
                        });
                })
                .catch((e) => {
                    Utils.modal("popup", true, this.modalI18nGenericOptions);

                    AnalyticsService.errorEvent("3_payment", "technical", "gproxy | get user consents error", e);
                });
        }
    };

    static #saveConsents = async () => {
        Trace.debug("saveConsents");

        const checkedConsents = {};

        this.#componentDom.querySelectorAll("#consents > div input").forEach((checkbox) => {
            checkedConsents[checkbox.name] = checkbox.checked;
        });

        this.#availableConsents.forEach((consent) => {
            checkedConsents[consent] = checkedConsents[consent] || window.snakeCheckout.accountInfo.userConsents.filter((item) => item.key === consent)[0]?.granted(consent) || false;
        });

        await Identity.setConsents(checkedConsents).catch((e) => {
            Trace.debug("setConsents error");
            Trace.debug(e);

            Utils.modal("popup", true, this.modalI18nGenericOptions);

            AnalyticsService.errorEvent("3_payment", "technical", "gproxy | set user consents error", e);

            return false;
        });

        return true;
    };

    static #validateOrderButton = () => {
        Trace.debug("validateOrderButton");

        let isValid = true;
        const btnSubmit = document.querySelector('button[id="create-order"]');
        const btnSubmitPaypal = document.getElementById("btn-dropin-paypal");
        const submitErrorDom = document.getElementById("submit-payment-error");

        btnSubmit.disabled = true;
        btnSubmitPaypal.classList.add("disabled");
        submitErrorDom.classList.add("hidden");

        if (window.snakeCheckout.currentCountry !== "us" && !document.getElementById("accept-terms").checked) {
            submitErrorDom.innerHTML = window.snakeCheckout.translations["error.payment.t&c"];
            isValid = false;
        }

        if (isValid && ["pl", "it"].includes(window.snakeCheckout.currentCountry) && document.getElementById("invoice-check").checked && document.querySelectorAll('#invoice-form [data-validate-check="false"]:not(:disabled)').length !== 0) {
            submitErrorDom.innerHTML = window.snakeCheckout.translations["error.payment.invoice"];
            isValid = false;
        }

        if (!isValid) submitErrorDom.classList.remove("hidden");
        else {
            btnSubmit.disabled = false;
            btnSubmitPaypal.classList.remove("disabled");
        }

        return isValid;
    };

    static #adyenCheckoutInit = async (session) => {
        // window.snakeCheckout.usingPaypal = false;

        return await AdyenCheckout({
            clientKey: import.meta.env.CO_ADYEN_CLIENT_KEY,
            environment: import.meta.env.CO_ADYEN_ENV,
            session,
            locale: (config.countries[window.snakeCheckout.currentCountry].lang || window.snakeCheckout.currentCountry) + "-" + (config.countries[window.snakeCheckout.currentCountry].code || window.snakeCheckout.currentCountry.toUpperCase()),
            showPayButton: false, // Shows or hides a Pay Button for each payment method. Defaults to true.
            paymentMethodsConfiguration: {
                // https://docs.adyen.com/payment-methods/cards/web-drop-in/
                card: {
                    name: window.snakeCheckout.translations["payment.creditcard.name"],
                    brands: ["visa", "mc", "amex"],
                    // showStoredPaymentMethods: false, // [DOESN'T WORK!!!] Set to false if you don't want Drop-in to show previously stored payment methods in the payment method list.
                    // enableStoreDetails: true, // Set to true to show the checkbox for saving the card details for recurring payments.
                    onError: (e) => {
                        // Called when Drop-in detects an invalid card number, invalid expiry date, or incomplete field. Called again when errors are cleared.

                        Trace.warn("CARD err");

                        this.#showDropinError();

                        AnalyticsService.errorEvent("3_payment", "technical", "Adyen Credit Card error", e);
                    },
                },
                sepadirectdebit: {
                    name: window.snakeCheckout.translations["payment.sepa.name"],
                    // enableStoreDetails: true,
                    // showStoredPaymentMethods: true,
                },
                c_invoice: {
                    name: window.snakeCheckout.translations["payment.invoice.name"],
                },
                c_cash: {
                    name: window.snakeCheckout.translations["payment.cash.name"],
                },
                klarna_account: {
                    name: window.snakeCheckout.translations["payment.klarna.name"] ?? "Klarna",
                },
            },
            onPaymentCompleted: (result, component) => {
                Trace.warn("SUBMIT CARD comp");
                this.#handlePaymentResponse(result);
            },
            onError: (error, component) => {
                Trace.warn("SUBMIT CARD err");
                this.#handlePaymentResponse(error);
            },
            // paypal: {
            //     // https://docs.adyen.com/payment-methods/paypal/web-drop-in/
            //     blockPayPalCreditButton: true,
            //     blockPayPalPayLaterButton: true,
            //     configuration: {
            //         intent: "authorize", // https://docs.adyen.com/payment-methods/paypal/web-drop-in/?tab=pp-risk-sessions_1#intent
            //     },
            //     style: {
            //         // https://developer.paypal.com/sdk/js/reference/#link-style
            //         layout: "vertical",
            //         color: "blue",
            //     },
            //     cspNonce: "MY_CSP_NONCE", // https://docs.adyen.com/payment-methods/paypal/web-drop-in/?tab=pp-risk-sessions_1#csp
            //     onInit: (data, actions) => {
            //         Trace.debug("general PP on init");
            //         Trace.debug(data);
            //         Trace.debug(actions);

            //         actions.enable();
            //     },
            //     onClick: (e) => {
            //         Trace.debug("general PP on click");
            //         Trace.debug(e);

            //         if (e.fundingSource === "paypal") window.snakeCheckout.usingPaypal = true;
            //     },
            //     onError: (e) => {
            //         Trace.debug("general PP on error");
            //         Trace.error(e);

            //         this.#showDropinError();

            //         AnalyticsService.errorEvent("3_payment", "technical", "Adyen PayPal error", e);
            //     },
            // },
        });
    };

    static #handlePaymentResponse = async (paymentResponse) => {
        Trace.debug("ADYEN RESULT");
        Trace.log(paymentResponse);

        this.#dropinErrorBox.classList.add("hidden");

        // https://docs.adyen.com/payment-methods/paypal/web-drop-in/?tab=pp-risk-sessions_1#get-the-payment-outcome
        switch (paymentResponse.resultCode) {
            // case "Pending": case "Received": break;
            case "Authorised":
                await ApiService.completeOrder(parseInt(Storage.get("order")), Storage.get("payment_method"), Storage.get("invoice") || false)
                    .then(() => this.#redirectToThankYouPage())
                    .catch((e) => {
                        this.#showDropinError();

                        AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | commerce order complete error", e);
                    });
                break;
            case "Refused":
                AnalyticsService.checkoutPurchaseFailed();

                this.#showDropinError();

                window.snakeCheckout.dropin.setStatus("ready");
                break;
            default:
                Utils.spinner("loader", false);

                this.#showDropinError();

                AnalyticsService.errorEvent("3_payment", "technical", "Adyen payment unmapped case", paymentResponse);
                break;
        }
    };

    static #renderAdyenDropin = async (adyenCheckoutInstance) => {
        const dropinContainer = document.getElementById("dropin-container");
        if (window.snakeCheckout.dropin) {
            window.snakeCheckout.dropin.unmount();
        }
        window.snakeCheckout.dropin = await adyenCheckoutInstance
            .create("dropin", {
                onSelect: async (component) => {
                    Trace.debug("Payment onSelect");
                    Trace.log(component);

                    /**
                     * Save the selected payment method on Local Storage to be able to use it on the Analytics data and the Thank You page
                     */
                    Storage.set("payment_method", component.props.type || "");

                    this.#dropinErrorBox.classList.add("hidden");

                    // window.snakeCheckout.usingPaypal = false;
                    // window.snakeCheckout.paymentMethod = component.props.type;

                    if (window.snakeCheckout.currentCountry === "it") {
                        document.querySelectorAll(".dispatchsubtitlepaymentdescription").forEach((item) => {
                            if (component.props.type === "c_invoice") item.classList.remove("line-through");
                            else item.classList.add("line-through");
                        });
                    }

                    const btnDropinDom = document.getElementById("btn-dropin-generic");
                    const btnDropinPaypalDom = document.getElementById("btn-dropin-paypal");

                    const klarnaTextDom = document.getElementById("klarna-text-container");
                    const klarnaWidgetDom = document.getElementById("klarna-widget-container");

                    if (component.props.type === "klarna_account") {
                        Utils.spinner("loader", true);

                        await ApiService.paymentInit({
                            cart_id: window.snakeCheckout.initData.cart_id,
                            order_id: Storage.get("order"),
                            full_price: true,
                        })
                            .then(async (response) => {
                                Trace.debug("paymentInit 2");
                                Trace.log(response);

                                if (response.data) {
                                    Trace.log("is Klarna");

                                    btnDropinDom.classList.add("hidden");
                                    btnDropinPaypalDom.classList.remove("hidden");

                                    Trace.debug(btnDropinDom.classList);

                                    klarnaTextDom.classList.remove("hidden");
                                    klarnaWidgetDom.classList.remove("hidden");

                                    window.snakeCheckout.iod = response.data.session.reference;
                                    window.snakeCheckout.orderId = response.data.order_id;

                                    /**
                                     * Save the order ID in local storage to avoid generating a new order if it already exists
                                     */
                                    Storage.set("order", response.data.order_id);

                                    /**
                                     * Save the customer first name in local storage to retrive for the Verify flow
                                     */
                                    Storage.set("firstname", window?.snakeCheckout?.accountInfo?.profile?.firstName || "");

                                    const adyenCheckoutInstance = await this.#adyenCheckoutInit(response.data.session);

                                    if (window.snakeCheckout.dropinKlarna) {
                                        Trace.debug("Unmount: window.snakeCheckout.dropinKlarna");
                                        window.snakeCheckout.dropinKlarna.unmount();
                                    }

                                    window.snakeCheckout.dropinKlarna = await adyenCheckoutInstance
                                        .create("klarna_account", {
                                            // https://docs.adyen.com/payment-methods/paypal/web-drop-in/
                                            // blockPayPalCreditButton: true,
                                            // blockPayPalPayLaterButton: true,
                                            showPayButton: true, // Shows or hides a Pay Button for each payment method. Defaults to true.
                                            configuration: {
                                                intent: "authorize", // https://docs.adyen.com/payment-methods/paypal/web-drop-in/?tab=pp-risk-sessions_1#intent
                                            },
                                            // style: {
                                            //     // https://developer.paypal.com/sdk/js/reference/#link-style
                                            //     layout: "vertical",
                                            //     color: "blue",
                                            // },
                                            onInit: (data, actions) => {
                                                Trace.debug("KN on init");
                                                Trace.debug(data);
                                                Trace.debug(actions);

                                                actions.enable();
                                                // document.getElementById("dropin-container").classList.remove("loading");
                                            },
                                            onClick: async (e) => {
                                                Trace.debug("KN on click");
                                                Trace.debug(e);

                                                Utils.spinner("loader", true);

                                                const isMismatching = this.#checkCardMismatchOnMultipleCheckoutPages();
                                                if (isMismatching) return false;

                                                if (window.snakeCheckout.type === "items") {
                                                    const isAvailable = await this.#checkItemsStock();
                                                    if (!isAvailable) return false;
                                                }

                                                if (!(await this.#saveInvoiceData())) return false;

                                                if (!(await this.#saveConsents())) return false;

                                                // window.snakeCheckout.usingPaypal = true;

                                                AnalyticsService.checkoutPaymentExecute();

                                                // return window.snakeCheckout.currentCountry !== "us" ? document.getElementById("accept-terms").checked : true;
                                            },
                                            onError: (e) => {
                                                Trace.debug("KN on error");

                                                Utils.spinner("loader", false);

                                                this.#showDropinError();

                                                AnalyticsService.errorEvent("3_payment", "technical", "Adyen Klarna error", e);
                                            },
                                        })
                                        .mount(btnDropinPaypalDom);

                                    // await this.#renderAdyenDropin(adyenCheckoutInstance);

                                    /*
                                    const autoPromotions = window.snakeCheckout.promotions.map((promotion) => {
                                        return promotion.auto ? promotion : {};
                                    });
                                    */

                                    // autoPromotions = [...autoPromotions, { auto: false, code: "40_DIP" }]; // just for test

                                    /*
                                    if (Object.keys(autoPromotions).length !== 0) {
                                        Trace.debug("PROMO");

                                        await ApiService.purchaseAddCoupon({
                                            coupon_codes: autoPromotions,
                                            order_id: response.data.order_id,
                                        })
                                            .then((coupon) => {
                                                Trace.debug("purchaseAddCoupon auto response");
                                                Trace.log(coupon);

                                                const promoBoxDom = document.querySelectorAll(".promo-box");

                                                autoPromotions.forEach((autoPromotion) => {
                                                    promoBoxDom.forEach((box) => {
                                                        if (box.childElementCount !== 1) {
                                                            box.lastElementChild.classList.add("mb-3");
                                                            box.appendChild(box.firstElementChild.cloneNode(true));
                                                        }

                                                        box.lastElementChild.innerHTML = window.snakeCheckout.dictionary["promo." + autoPromotion.code] || "[Dictionary]: promo." + autoPromotion.code;

                                                        box.classList.remove("hidden");
                                                    });
                                                });

                                                document.querySelector("#toggle-mobile-summary div:not(:first-child)").classList.remove("hidden");

                                                Storage.set(
                                                    "promotions",
                                                    autoPromotions.map((promotion) => promotion.code)
                                                );

                                                document.querySelector("details").remove();
                                            })
                                            .catch((e) => {
                                                Trace.debug("purchaseAddCoupon auto error");
                                                Trace.debug(e);

                                                Utils.modal("popup", true, this.modalI18nGenericOptions);

                                                AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | add coupon auto error", e);

                                                // Utils.modal("popup", true, { text: window.snakeCheckout.translations["promo.notvalid"], dismissBtn: this.modalI18nGenericOptions.dismissBtn });
                                            });
                                    }
                                    */

                                    /**
                                     * TEMP
                                     */
                                    // const initData = JSON.parse(Storage.get("init"));
                                    // Storage.set("init", JSON.stringify(initData));
                                    // Storage.set("payment_method", "card");
                                    // Storage.set("firstname", window.snakeCheckout.accountInfo.profile.firstName || "");
                                    /**
                                     * TEMP
                                     */
                                } else throw Error(response.error.message || "payment init 2 response data error");
                            })
                            .catch((e) => {
                                document.querySelectorAll("#btn-dropin-paypal, #btn-dropin-generic").forEach((element) => element.remove());

                                Utils.modal("popup", true, this.modalI18nGenericOptions);

                                AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | payment init error", e);
                            });

                        Utils.spinner("loader", false);
                    }
                    // else {
                    //     btnDropinPaypalDom.classList.add("hidden", "disabled");
                    //     btnDropinDom.classList.remove("hidden");
                    // }
                    else if (component.props.type === "paypal") {
                        Trace.log("is PayPal");

                        btnDropinDom.classList.add("hidden");
                        btnDropinPaypalDom.classList.remove("hidden");

                        klarnaTextDom.classList.add("hidden");
                        klarnaWidgetDom.classList.add("hidden");

                        if (window.snakeCheckout.dropinPaypal) {
                            window.snakeCheckout.dropinPaypal.unmount();
                        }

                        window.snakeCheckout.dropinPaypal = await adyenCheckoutInstance
                            .create("paypal", {
                                // https://docs.adyen.com/payment-methods/paypal/web-drop-in/
                                blockPayPalCreditButton: true,
                                blockPayPalPayLaterButton: true,
                                showPayButton: true, // Shows or hides a Pay Button for each payment method. Defaults to true.
                                configuration: {
                                    intent: "authorize", // https://docs.adyen.com/payment-methods/paypal/web-drop-in/?tab=pp-risk-sessions_1#intent
                                },
                                style: {
                                    // https://developer.paypal.com/sdk/js/reference/#link-style
                                    layout: "vertical",
                                    color: "blue",
                                },
                                onInit: (data, actions) => {
                                    Trace.debug("PP on init");
                                    Trace.debug(data);
                                    Trace.debug(actions);

                                    actions.enable();
                                    // document.getElementById("dropin-container").classList.remove("loading");
                                },
                                onClick: async (e) => {
                                    Trace.debug("PP on click");
                                    Trace.debug(e);

                                    const isMismatching = this.#checkCardMismatchOnMultipleCheckoutPages();
                                    if (isMismatching) return false;

                                    if (window.snakeCheckout.type === "items") {
                                        const isAvailable = await this.#checkItemsStock();
                                        if (!isAvailable) return false;
                                    }

                                    if (!(await this.#saveInvoiceData())) return false;

                                    if (!(await this.#saveConsents())) return false;

                                    // window.snakeCheckout.usingPaypal = true;

                                    AnalyticsService.checkoutPaymentExecute();

                                    // return window.snakeCheckout.currentCountry !== "us" ? document.getElementById("accept-terms").checked : true;
                                },
                                onError: (e) => {
                                    Trace.debug("PP on error");
                                    Trace.print(e);

                                    if ((e.name ?? "") !== "CANCEL") {
                                        this.#showDropinError();

                                        AnalyticsService.errorEvent("3_payment", "technical", "Adyen PayPal error", e);
                                    }
                                },
                            })
                            .mount(btnDropinPaypalDom);

                        this.#validateOrderButton();
                    } else {
                        btnDropinPaypalDom.classList.add("hidden", "disabled");
                        btnDropinDom.classList.remove("hidden");

                        klarnaTextDom.classList.add("hidden");
                        klarnaWidgetDom.classList.add("hidden");
                    }

                    if (window.snakeCheckout.currentCountry === "us") {
                        document.querySelector('button[id="create-order"]').disabled = false;
                        document.getElementById("btn-dropin-paypal").classList.remove("disabled");
                    }
                },
                onReady: () => {
                    const klarnaDropinContainer = document.querySelector("#dropin-container > div > ul li.adyen-checkout__payment-method.adyen-checkout__payment-method--klarna_account > div:first-child");

                    if (klarnaDropinContainer) {
                        const span = document.createElement("span");
                        span.classList.add("disclaimer");
                        span.innerHTML = window.snakeCheckout.translations["payment.klarna.text"] ?? "";

                        klarnaDropinContainer.appendChild(span);
                    }
                },
            })
            .mount(dropinContainer);
    };

    static #showDropinError = () => {
        // override error message generic
        if (window.snakeCheckout.dictionary["checkout.payments.errors.generic.message"]) {
            this.#dropinErrorBox.innerHTML = window.snakeCheckout.dictionary["checkout.payments.errors.generic.message"];
        }
        this.#dropinErrorBox.classList.remove("hidden");

        window.scrollTo({
            top: this.#dropinErrorBox.offsetTop - 150,
            left: 0,
            behavior: "smooth",
        });
    };

    static #saveInvoiceData = async () => {
        Storage.delete("invoice");

        if (["pl", "it"].includes(window.snakeCheckout.currentCountry) && document.getElementById("invoice-check").checked) {
            Trace.debug("#saveInvoiceData");

            const shippingAddresses = [...window.snakeCheckout.accountInfo.data.shippingAddresses];
            window.snakeCheckout.accountInfo.data.shippingAddressesOnOtherCountries.forEach((address) => shippingAddresses.push(address));

            window.snakeCheckout.accountInfo.data.billingAddress.taxCode = document.querySelector("#invoice-form #fiscal-code").value;
            window.snakeCheckout.accountInfo.data.billingAddress.VATCode = document.querySelector("#invoice-form #vat-number").value;

            if (window.snakeCheckout.currentCountry === "it") {
                window.snakeCheckout.accountInfo.data.billingAddress.emailCertified = document.querySelector("#invoice-form #pec").value;
                window.snakeCheckout.accountInfo.data.billingAddress.SDI = document.querySelector("#invoice-form #sdi-number").value;
            }

            await Identity.setAddresses(shippingAddresses, window.snakeCheckout.accountInfo.data.billingAddress)
                .then(async (response) => {
                    if (response.errorCode !== 0) {
                        Utils.modal("popup", true, this.modalI18nGenericOptions);

                        AnalyticsService.errorEvent("3_payment", "technical", "gproxy | set user invoice response error", response);

                        return false;
                    } else {
                        Storage.set("invoice", true);
                    }
                })
                .catch((e) => {
                    Trace.debug("saveInvoiceData error");
                    Trace.debug(e);

                    Utils.modal("popup", true, this.modalI18nGenericOptions);

                    AnalyticsService.errorEvent("3_payment", "technical", "gproxy | set user invoice error", e);

                    return false;
                });
        }

        return true;
    };

    static #submitOrder = async () => {
        Trace.warn("submitOrder");

        const isMismatching = this.#checkCardMismatchOnMultipleCheckoutPages();
        if (isMismatching) return false;

        if (window.snakeCheckout.type === "items") {
            const isAvailable = this.#checkItemsStock();
            if (!isAvailable) return false;
        }

        Trace.warn(Storage.get("payment_method"));

        if (["c_invoice", "c_cash"].includes(Storage.get("payment_method"))) {
            Trace.warn("SUBMIT: INVOICE & CASH");

            await ApiService.completeOrder(parseInt(Storage.get("order")), Storage.get("payment_method"), Storage.get("invoice") || false)
                .then(() => this.#redirectToThankYouPage())
                .catch((e) => {
                    Trace.debug("completeOrder");
                    Trace.debug(e);

                    this.#showDropinError();

                    AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | commerce order complete error", e);
                });
        } else {
            Trace.warn("SUBMIT: CARD & KLARNA & PAYPAL");

            Trace.log(window.snakeCheckout.dropin);

            try {
                switch (Storage.get("payment_method")) {
                    case "paypal":
                        window.snakeCheckout.dropinPaypal.submit();
                        break;
                    case "klarna_account":
                        window.snakeCheckout.dropinKlarna.submit();
                        break;
                    default:
                        window.snakeCheckout.dropin.submit();
                        break;
                }
            } catch (e) {
                this.#showDropinError();

                Trace.error(e);

                AnalyticsService.errorEvent("3_payment", "technical", "Adyen dropin submit error", e);
            }
        }
    };

    static #checkCardMismatchOnMultipleCheckoutPages = () => {
        /**
         * if the user opens several checkout pages with different products, in localstorage we have the SKU of the last loaded product
         * page, so if the user then returns to the tab of the first loaded product, he will not buy the product displayed but the one
         * related to the SKU in localstorage, which will be the one of the last product page loaded. We add a check to block the
         * order.
         */

        const [sku, cartId, abandonedCart] = Url.getParametes(["sku", "cart_id", "cartId"]);

        if (Storage.get("current_purchase") !== (sku ?? cartId ?? abandonedCart)) {
            Utils.modal("popup", true, this.modalI18nGenericOptions);

            AnalyticsService.errorEvent("3_payment", "behavior", "purchase reference mismatch due to multiple open checkout pages");

            return true;
        }

        return false;
    };

    static #checkItemsStock = async () => {
        let available = false;
        const props = {
            country: window.snakeCheckout.currentCountry,
            skus: [],
        };

        window.snakeCheckout.initData.items.refs.forEach((item) => props.skus.push(item.item));

        await ApiService.getItemsStock(props)
            .then((result) => {
                Trace.debug("getItemsStock");
                Trace.debug(result);

                let outOfStockItems = "";
                const items = JSON.parse(Storage.get("items"));

                Object.entries(result).forEach((item) => {
                    if (parseInt(item[1]) <= 0) outOfStockItems += "<li class='list-disc'>" + items.filter((cartItem) => cartItem.sku === item[0])[0].name + "</li>" ?? "";
                });

                if (outOfStockItems.length === 0) {
                    available = true;
                } else {
                    Utils.modal("popup", true, {
                        ...this.modalI18nGenericOptions,
                        text: "The following products are out of stock:<ul class='pl-4'>" + outOfStockItems + "</ul>",
                    });
                }
            })
            .catch((e) => {
                Trace.debug("getItemsStock error");
                Trace.debug(e);

                Utils.modal("popup", true, this.modalI18nGenericOptions);

                AnalyticsService.errorEvent("3_payment", "technical", "snakeAPI | check stock error", e);
            });

        return available;
    };

    static #redirectToThankYouPage = () => {
        const initData = JSON.parse(Storage.get("init"));
        const paymentMethod = Storage.get("payment_method");
        const order = Storage.get("order");
        const items = Storage.get("items");
        const price = Storage.get("price");
        const shipping = Storage.get("shipping");
        const promotions = Storage.get("promotions");
        const isAgent = Storage.get("agent") === "true";
        const defaultShippingAddress = JSON.parse(Storage.get("shipping_address"));

        Storage.clear(() => {
            /**
             * Save some info on Local Storage to be able to use them on the Thank You page
             */
            Storage.set("init", JSON.stringify(initData));
            Storage.set("payment_method", paymentMethod);
            Storage.set("firstname", window.snakeCheckout.accountInfo.profile.firstName || "");
            Storage.set("IOD", window.snakeCheckout.iod);
            Storage.set("items", items);
            Storage.set("price", price);
            Storage.set("shipping", shipping);
            Storage.set("order", order);
            Storage.set("promotions", promotions);
            Storage.set("shipping_address", JSON.stringify(defaultShippingAddress));

            if (window?.snakeCheckout?.shippingEstimationText) Storage.set("shipping_text", window.snakeCheckout.shippingEstimationText);

            setTimeout(() => {
                window.location.href = "/" + config.countries[window.snakeCheckout.currentCountry].countryCode.toLowerCase() + (window.snakeCheckout.type === "subscription" ? "/subscribe/" : "/purchase/") + "confirmation" + (isAgent ? "-agent" : "");
            }, 500);
        });
    };
}
